import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ItemsService} from '../commons/items.service';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    constructor(private http: HttpClient) {}

    get() {
        return this.http.get<any>(ItemsService.API_URL+'config');
    }
    save(params:any) {
        return this.http.post<any>(ItemsService.API_URL+'config', params);
    }
}
